<template>
  <v-badge
    v-if="icon"
    bordered
    bottom
    left
    offset-x="16"
    offset-y="16"
  >
    <template #badge>
      <v-icon size="12" v-text="icons[icon]" />
    </template>
    <h-avatar
      :resource="resource"
    />
  </v-badge>
  <h-avatar
    v-else
    :resource="resource"
  />
</template>

<script>
  import UsesIcons from '@/Mixins/UsesIcons'
  import HAvatar from './Avatar'

  export default {
    mixins: [
      UsesIcons,
    ],

    components: {
      HAvatar,
    },

    props: {
      resource: {
        required: true,
        type: Object,
      },
      icon: {
        required: false,
        type: String,
      },
    },
  }
</script>
